import { IAgricultureParameter } from '@/modules/agriculture/ts';
import { ISearchState, IWheatData } from '@/modules/search/ts/index.types';
import { notification } from 'antd';

export function validateRangesModal(
  modalState: ISearchState,
  wheatRangesForValidation: {
    gluten: IAgricultureParameter;
    humidity: IAgricultureParameter;
    idk: IAgricultureParameter;
    cp: IAgricultureParameter;
    protein: IAgricultureParameter;
    nature: IAgricultureParameter;
  },
) {
  const ranges = wheatRangesForValidation;
  const checkedStores = modalState.stores.filter((item) => item.checked);
  const result: IResult = {
    errors: [],
    warnings: [],
    success: true,
  };
  if (!modalState.wheatData.sort || !modalState.wheatData.type)
    result.warnings.push({ label: 'Не выбран сорт/тип пшеницы' });
  if (!checkedStores || checkedStores.length === 0)
    result.warnings.push({ label: 'Не выбраны склады для поиска!' });

  // GLUTEN
  if (
    !isWithinRange(
      ranges.gluten.options as { min: number; max: number },
      modalState.rangesData.gluten as unknown as [number, number],
    )
  ) {
    result.warnings.push({
      label: generateWarningString(ranges.gluten),
    });
  }

  // HUMIDITY
  if (
    !isWithinRange(
      ranges.humidity.options as { min: number; max: number },
      modalState.rangesData.humidity as unknown as [number, number],
    )
  ) {
    result.warnings.push({
      label: generateWarningString(ranges.humidity),
    });
  }

  // CP
  if (
    !isWithinRange(
      ranges.cp.options as { min: number; max: number },
      modalState.rangesData.cp as unknown as [number, number],
    )
  ) {
    result.warnings.push({
      label: generateWarningString(ranges.cp),
    });
  }

  // NATURE
  if (
    !isWithinRange(
      ranges.nature.options as { min: number; max: number },
      modalState.rangesData.nature as unknown as [number, number],
    )
  ) {
    result.warnings.push({
      label: generateWarningString(ranges.nature),
    });
  }

  // PROTEIN
  if (
    !isWithinRange(
      ranges.protein.options as { min: number; max: number },
      modalState.rangesData.protein as unknown as [number, number],
    )
  ) {
    result.warnings.push({
      label: generateWarningString(ranges.protein),
    });
  }

  // IDK
  if (
    !isWithinRange(
      ranges.idk.options as { min: number; max: number },
      modalState.rangesData.idk as unknown as [number, number],
    )
  ) {
    result.warnings.push({
      label: generateWarningString(ranges.idk),
    });
  }

  if (result.errors.length > 0 || result.warnings.length > 0) result.success = false;
  return result;
}

interface IResult {
  errors: string[];
  warnings: { label: string }[];
  success: boolean;
}

function isWithinRange(range: { min: number; max: number }, values: [number, number]) {
  const checkerRange = [range.min, range.max];
  const [minRange, maxRange] = checkerRange;
  const valuesParsed = [parseFloat(String(values[0])), parseFloat(String(values[1]))];
  const [val1, val2] = valuesParsed;

  return val1 >= minRange && val1 <= maxRange && val2 >= minRange && val2 <= maxRange;
}

function generateWarningString(wheatParam: IAgricultureParameter) {
  return `Допустимый диапазон для параметра '${wheatParam.name}' ${wheatParam.options.min}-${wheatParam.options.max}. Введите корректное значение.`;
}
